import { Injectable, isDevMode } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
@Injectable({
    providedIn: 'root',
})
export class ApplicationLanguageService {
    constructor(private cookieService: CookieService) {}

    loadForLanguage(language: string) {
        if (isDevMode()) {
            console.log('Running in DEV mode - not redirecting for language ' + language);
            return;
        }

        const currentLanguage = this.getCurrentLanguage();
        if (language !== currentLanguage) {
            console.log('Reloading application for language ' + language + ' - current language is ' + currentLanguage);
            this.setCurrentLanguage(language);
            window.location.reload();
        } else {
            console.log('No need to reload application for language ' + language);
        }
    }

    private setCurrentLanguage(language: string) {
        const nbDays = 10;
        const secure = true;
        const sameSite = 'Lax';
        this.cookieService.set('app.language', language, nbDays, '/', null, secure, sameSite);
    }

    private getCurrentLanguage(): string {
        const currentLanguage = this.cookieService.get('app.language');
        return currentLanguage;
    }
}
